module.exports = __webpack_public_path__ + "img/shopping-bag-grey.cc4557ca.svg";